import {Card, List, Space} from 'antd';
import {ListItemMetaProps} from 'antd/es/list';
import cn from 'classnames';
import React, {ReactNode} from 'react';

import 'components/@common/specific/list-array-factory/list-array-factory.less';

export interface IListArrayItem {
    listTitle: string;
    list: ListItemMetaProps[];
    useButtonsBottomMargin?: boolean;
    buttons?: ReactNode[];
}

export interface IListArrayFactoryProps {
    listArrayDescription: IListArrayItem[];
    listClassName?: cn.Argument;
}

export const ListArrayFactory = ({
    listArrayDescription,
    listClassName,
}: IListArrayFactoryProps) => (
    <div className="list-array-factory">
        {listArrayDescription.map(({
            listTitle,
            list,
            buttons,
            useButtonsBottomMargin,
        }) => (
            <>
                <Card
                    bordered={false}
                    title={listTitle}
                    key={listTitle}
                >
                    <List
                        className={cn(listClassName)}
                        itemLayout="vertical"
                        size="small"
                        pagination={false}
                        dataSource={list}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    title={item.title}
                                    description={item.description}
                                />
                            </List.Item>
                        )}
                    />
                </Card>
                {Boolean(buttons?.length) && (
                    <Space
                        size={16}
                        className={cn('buttons', useButtonsBottomMargin && 'with-bottom-margin')}
                    >
                        {buttons}
                    </Space>
                )}
            </>
        ))}
    </div>
);
